import React from "react";
import moment from "moment";

export const UploadStatus = ({ status }) => {
  const { bgColor, color } = getColor(status);

  return (
    <div
      style={{
        backgroundColor: bgColor,
        width: "85px",
        maxWidth: "90px",
        padding: "0.2rem 0",
        borderRadius: "8px",
        textAlign: "center",
      }}
    >
      <span
        style={{
          fontSize: "12px",
          color,
          textTransform: "capitalize",
        }}
      >
        {status?.toLowerCase()}
      </span>
    </div>
  );
};

function getColor(status) {
  switch (status?.toLowerCase()) {
    case "success":
      return { bgColor: "#BBE2CE", color: "#0B442D" };
    case "processing":
      return { bgColor: "#FFEDC8", color: "#705010" };
    case "failed":
      return { bgColor: "#F9D9D7", color: "#B32306" };
    default:
      return { bgColor: "#F5F5F5", color: "#262626" };
  }
}

export const formattedDate = (timestamp) =>
  moment(timestamp).format("DD-MM-YYYY on hh:mm A");

export const UPLOAD_STATUS = [
  {
    label: "Success",
    value: "SUCCESS",
  },
  {
    label: "Failed",
    value: "FAILED",
  },
];

export const DEFAULT_FILTERS = {
  status: [],
  fromDate: "",
  toDate: "",
};

export const InputLabelStyle = {
  fontFamily: "Gilroy-Regular",
  fontSize: "12px",
  lineHeight: "14px",
  color: "#414141",
  marginTop: "10px",
  fontWeight: "500",
};
